// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__3ggbB","item":"styles_item__5sDsK","link":"styles_link__32hSY","hint":"styles_hint__1Yjy2","loading":"styles_loading__32Suz"};